export interface DrawScaledImageProps {
  image?: HTMLImageElement;
  context: CanvasRenderingContext2D;
  width: number;
  height: number;
}

export const drawScaledImage = ({ image, context, width, height }: DrawScaledImageProps) => {
  if (!image) {
    return;
  }

  const viewRatio = height / width;
  const imgRatio = image.height / image.width;

  if (imgRatio > viewRatio) {
    const drawHeight = width * imgRatio;
    context.drawImage(image, 0, (height - drawHeight) / 2, width, drawHeight);
  }

  if (imgRatio < viewRatio || imgRatio === viewRatio) {
    const drawWidth = (width * viewRatio) / imgRatio;
    context.drawImage(image, (width - drawWidth) / 2, 0, drawWidth, height);
  }
};
